const PREVIEW_ORCHESTRATION = `https://previews.cimpress.io`;

const generateInstructionsUri = (
    sku?: string,
    variables?: Record<string, any>,
    skuVersion?: number,
    image?: string,
) => {
    let temp =
        `${PREVIEW_ORCHESTRATION}/v2/sampledoc?sku=${encodeURIComponent(sku || '')}` +
        `${skuVersion && skuVersion >= 1 ? `&version=${skuVersion}` : ''}` +
        `${
            Object.keys(variables || {}).length ? `&skuVariables=${encodeURIComponent(JSON.stringify(variables))}` : ''
        }`;
    if (image) {
        temp = `${temp}&imageUris=${encodeURIComponent(image)}`;
    }

    return temp;
};

const renderingDomains: Record<string, string> = {
    'us-east': 'https://origin-prod-us-east-1.rendering.documents.cimpress.io',
    'eu-west': 'https://origin-prod-eu-west-1.rendering.documents.cimpress.io',
    'ap-northeast': 'https://origin-prod-ap-northeast-1.rendering.documents.cimpress.io',
    china: 'https://origin-rendering.yinshida.com.cn',
    auto: `https://rendering.documents.cimpress.io`,
};

const PINNED_REGION = import.meta.env.VITE_E2E_PIN_RENDERING_REGION;

function getDomain(region = 'auto') {
    const effective = PINNED_REGION || region;
    return renderingDomains[effective] || renderingDomains.auto;
}

type GeneratePreviewParams = {
    url: string;
    size: number;
    useWidth: boolean;
    region?: string;
    instructionsUri: string;
};
function generatePreview({
    url,
    size = 500,
    useWidth = false,
    region = 'auto',
    instructionsUri = generateInstructionsUri(),
}: GeneratePreviewParams) {
    if (!url) {
        return undefined;
    }
    const instructions = instructionsUri ? `&instructions_uri=${encodeURIComponent(instructionsUri)}` : '';
    const scene = `scene=${encodeURIComponent(url)}`;
    const dimension = `${useWidth ? 'width' : 'height'}=${size}`;
    return `${getDomain(region)}/v1/cse/preview?${dimension}&${scene}&timepreview=1&format=webp${instructions}`;
}

type GeneratePreviewUsingSkuParams = {
    url: string;
    size: number;
    useWidth: boolean;
    region?: string;
    sku: string;
    skuVersion: number;
    variables: Record<string, any>;
};
function generatePreviewUsingSku({
    url,
    size,
    useWidth,
    region,
    sku,
    skuVersion,
    variables,
}: GeneratePreviewUsingSkuParams) {
    return generatePreview({
        url,
        size,
        useWidth,
        region,
        instructionsUri: generateInstructionsUri(sku, variables, skuVersion),
    });
}

export { PREVIEW_ORCHESTRATION, generatePreview, generatePreviewUsingSku, generateInstructionsUri };
